<template>
  <svg
    class="use-icon-font"
    aria-hidden="true"
    :style="iconStyle"
    @click="handleClick"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script>
export default {
  name: 'UseIconFont',

  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: '16px',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },

  computed: {
    symbolId() {
      return `#icon-${this.name}`;
    },

    iconStyle() {
      const size = typeof this.size === 'number' ? `${this.size}px` : this.size;
      return {
        fontSize: size,
        color: this.color,
      };
    },
  },

  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style scoped>
.use-icon-font {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  display: inline-block;
}
</style>
